
<template>
  <el-dialog v-model="dialogVisible" title="请使用支付宝扫码支付" width="40%" center @open="handleDialogOpen" @close="handleDialogClose">
    <div class="payment-content">

      <div  class="qr-wrapper">
        <div  class="form-container" v-html="qrContent"></div> <!-- 直接显示form表单内容 -->
         <iframe  name="alipayIframe" class="payment-iframe"></iframe> <!-- 用于承载支付页面的iframe -->
        </div>
        <div class="form-container" >
        
      </div> 

        
      <ul class="payment-notes">
        <li>放心购买：未用币支持退款，您可前往个人中心退款（活动赠送币不支持退款）。</li>
        <li>实时到账：充值完成关闭此页面即可，充值将实时到账，您可在个人中心可查看当前币</li>
        <li>联系我们：若支付遇到问题，请 <a href="#" @click.prevent="goToContact">联系我们</a></li>
      </ul>
    </div>
  </el-dialog>
</template>

<script>
export default {
  data() {
    return {
      dialogVisible: false,
      qrContent: ''// 存储form表单内容
    };
  },
  methods: {
    handleDialogClose() {

      this.$emit('close-modal');
    },


    showPaymentModal() {
      this.dialogVisible = true;
    },
    setQrContent(formHtml) {
      // 存储form表单内容
      console.log('接收到的formHtml内容:', formHtml);
      this.qrContent = formHtml;
    },
    handleDialogOpen() {
      // 弹窗完全打开后执行表单提交
      this.$nextTick(() => {
        // 输出当前页面所有form元素的name属性
        const allForms = document.querySelectorAll('form');
        console.log('当前页面存在的form元素数量:', allForms.length);
        allForms.forEach((form, index) => {
          console.log(`form[${index}]的name属性:`, form.getAttribute('name'));
        });
        // 尝试查找目标form
        const targetForm = document.querySelector('form[name="punchout_form"]');
        if (targetForm) {
          console.log('成功找到punchout_form表单，准备提交');
          targetForm.setAttribute('target', 'alipayIframe'); // 设置表单提交目标为iframe
          targetForm.submit();
        } else {
          console.error('未找到name为punchout_form的支付表单，当前所有form元素已打印如上');
        }
      });
    },
    goToContact() {
      this.$router.push({
        name: 'home',
        query: { activeIndex: 5 }
      });
    }
  }
};
</script>

<style scoped>
.payment-content {
  text-align: center;
  padding: 20px;
}

.qr-wrapper {
  /* 二维码容器样式 */
  display: flex;
  /* 使用flex布局使内容居中 */
  justify-content: center;
  /* 水平居中 */
  align-items: center;
  /* 垂直居中 */
  width: 100%;
  /* 占满父容器宽度 */
  min-height: 250px;
  /* 最小高度，适配iframe */
  max-height: 500px;
  /* 最大高度 */
  margin: 20px auto;
  /* 上下外边距20px，左右居中 */
  padding: 10px;
  /* 适当内边距 */
  overflow: visible;
  /* 允许内容显示 */
}

.form-container {
  display: flex;
  justify-content: center;
  align-items: center;
  width: auto;
  /* 自动调整宽度 */
  height: auto;
  /* 自动调整高度 */
  padding: 0;
  margin: 0;
}

.form-container form {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  width: auto;
  /* 自动调整宽度 */
  height: auto;
  /* 自动调整高度 */
  padding: 0;
  margin: 0;
}

.form-container img {
  display: block;
  margin: 0;
  max-width: 100%;
  max-height: 100%;
  width: auto;
  height: auto;
  object-fit: contain;
  border-radius: 8px;
}

.payment-iframe {
  width: 220px;
  /* 设置宽度略大于二维码，为居中留出空间 */
  height: 220px;
  /* 设置高度与宽度相同，形成正方形 */
  border: none;
  display: block;
  margin: 0 auto;
  /* 水平居中 */
  max-width: 100%;
  /* 确保不超出容器 */
  /* 强制iframe内部内容居中 */
  transform: scale(1);
  overflow: hidden;
}

/* 通过CSS注入来强制iframe内部内容居中 */
.payment-iframe::after {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  pointer-events: none;
  background: transparent;
}

/* 尝试通过CSS影响iframe内部内容 */
.payment-iframe {
  /* 添加一些样式来影响iframe内部布局 */
  position: relative;
}

/* 为iframe添加一个包装容器来强制居中 */
.qr-wrapper {
  position: relative;
}

/* 如果iframe内容可以控制，添加这些样式 */
.payment-iframe iframe,
.payment-iframe body,
.payment-iframe div {
  text-align: center !important;
  display: flex !important;
  justify-content: center !important;
  align-items: center !important;
  margin: 0 auto !important;
}

.qr-code-container {
  margin: 20px auto;
}

.qr-code-container canvas {
  display: block;
  margin: 0 auto;
  width: 200px;
  height: 200px;
}

.success-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 20px;
  text-align: center;
}

.success-icon {
  font-size: 48px;
  color: #67C23A;
  margin-bottom: 16px;
}

.success-text {
  font-size: 24px;
  font-weight: bold;
  color: #67C23A;
  margin: 0;
}

.refresh-btn {
  margin-bottom: 20px;
}

.payment-notes {
  list-style-type: disc;
  padding-left: 20px;
  text-align: left;
  margin-top: 20px;
  color: #666;
}

.payment-notes li {
  margin: 10px 0;
}

.payment-notes a {
  color: #409EFF;
  text-decoration: none;
}

/* 移动设备适配 */
@media (max-width: 768px) {
  .el-dialog {
    width: 95vw !important;
    max-width: 95vw !important;
    margin: 2.5vw auto !important;
  }

  .payment-content {
    padding: 16px;
  }

  .qr-wrapper {
    min-width: 160px;
    max-width: 200px;
    min-height: 160px;
    max-height: 300px;
    margin: 16px auto;
  }

  .form-container img {
    max-width: 100%;
    max-height: 100%;
    width: auto;
    height: auto;
  }

  .qr-code-container {
    margin: 16px auto;
  }

  .qr-code-container canvas {
    width: 160px;
    height: 160px;
  }

  .refresh-btn {
    margin-bottom: 16px;
  }

  .payment-notes {
    padding-left: 16px;
    margin-top: 16px;
    font-size: 13px;
  }

  .payment-notes li {
    margin: 8px 0;
    line-height: 1.5;
  }

  .payment-iframe {
    height: 240px !important;
    width: 240px;
    /* 移动端正方形，适合200px二维码 */
    margin: 0 auto;
  }

  .success-content {
    padding: 16px;
  }

  .success-icon {
    font-size: 36px;
    margin-bottom: 12px;
  }

  .success-text {
    font-size: 18px;
  }
}

/* 平板设备适配 */
@media (min-width: 769px) and (max-width: 1024px) {
  .el-dialog {
    width: 80vw !important;
    max-width: 80vw !important;
  }

  .payment-content {
    padding: 20px;
  }

  .qr-wrapper {
    min-width: 180px;
    max-width: 250px;
    min-height: 180px;
    max-height: 350px;
  }

  .form-container img {
    max-width: 100%;
    max-height: 100%;
    width: auto;
    height: auto;
  }

  .qr-code-container canvas {
    width: 180px;
    height: 180px;
  }

  .payment-notes {
    font-size: 14px;
  }

  .payment-notes li {
    margin: 9px 0;
  }

  .payment-iframe {
    height: 260px !important;
    width: 260px;
    /* 平板端正方形，适合200px二维码 */
    margin: 0 auto;
  }

  .success-content {
    padding: 18px;
  }

  .success-icon {
    font-size: 42px;
    margin-bottom: 14px;
  }

  .success-text {
    font-size: 21px;
  }
}

/* 小屏手机适配 */
@media (max-width: 480px) {
  .el-dialog {
    width: 98vw !important;
    max-width: 98vw !important;
    margin: 1vw auto !important;
  }

  .payment-content {
    padding: 12px;
  }

  .qr-wrapper {
    min-width: 140px;
    max-width: 180px;
    min-height: 140px;
    max-height: 280px;
    margin: 12px auto;
  }

  .form-container img {
    max-width: 100%;
    max-height: 100%;
    width: auto;
    height: auto;
  }

  .qr-code-container {
    margin: 12px auto;
  }

  .qr-code-container canvas {
    width: 140px;
    height: 140px;
  }

  .refresh-btn {
    margin-bottom: 12px;
  }

  .payment-notes {
    padding-left: 12px;
    margin-top: 12px;
    font-size: 12px;
  }

  .payment-notes li {
    margin: 6px 0;
    line-height: 1.4;
  }

  .payment-iframe {
    height: 220px !important;
    width: 220px;
    /* 小屏手机正方形，适合200px二维码 */
    margin: 0 auto;
  }

  .success-content {
    padding: 12px;
  }

  .success-icon {
    font-size: 32px;
    margin-bottom: 10px;
  }

  .success-text {
    font-size: 16px;
  }
}

/* 横屏手机适配 */
@media (max-width: 900px) and (max-height: 600px) {
  .el-dialog {
    width: 90vw !important;
    max-width: 90vw !important;
    max-height: 90vh !important;
    overflow-y: auto;
  }

  .payment-content {
    padding: 16px;
  }

  .qr-wrapper {
    min-width: 150px;
    max-width: 200px;
    min-height: 150px;
    max-height: 300px;
  }

  .form-container img {
    max-width: 100%;
    max-height: 100%;
    width: auto;
    height: auto;
  }

  .qr-code-container canvas {
    width: 150px;
    height: 150px;
  }

  .payment-notes {
    font-size: 13px;
  }

  .payment-notes li {
    margin: 7px 0;
  }

  .payment-iframe {
    height: 230px !important;
    width: 230px;
    /* 横屏手机正方形，适合200px二维码 */
    margin: 0 auto;
  }

  .success-content {
    padding: 14px;
  }

  .success-icon {
    font-size: 38px;
    margin-bottom: 11px;
  }

  .success-text {
    font-size: 19px;
  }
}
</style>